(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["payday-sale-page"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('payday-shop')) {
    customElements.define('payday-shop', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.addEventListener('submit', async event => {
          const form = event.target.closest('.pd-buy');
          if (!form) return;
          event.preventDefault();
          const button = form.querySelector('button');
          if (button.disabled) return;
          const original = button.innerHTML;
          button.disabled = true;
          button.textContent = this.dataset.adding;
          const status = this.querySelector('.pd-cart-status');
          try {
            const response = await fetch(this.dataset.addUrl, {method:'POST', headers:{Accept:'application/json'}, body:new FormData(form)});
            const result = await response.json();
            if (!response.ok) throw new Error(result.description || this.dataset.error);
            button.textContent = this.dataset.added;
            status.querySelector('p').textContent = this.dataset.success;
            status.hidden = false;
            if (typeof window.monster_refresh === 'function') window.monster_refresh(true);
          } catch (error) {
            status.querySelector('p').textContent = error.message || this.dataset.error;
            status.hidden = false;
          } finally {
            window.setTimeout(() => { button.innerHTML = original; button.disabled = false; }, 1600);
          }
        });
        this.querySelector('.pd-cart-status button').addEventListener('click', () => { this.querySelector('.pd-cart-status').hidden = true; });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
